import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"
const ContentHeader = styled.header`
  width: 100%;
  height: 100px;
  padding-top: 55px;
  display: flex;
  position: fixed;
  z-index: 20;
  background-color: transparent;
  transition:
    height 0.5s ease,
    background-color 0.5s ease;
  @media (max-width: 550px) {
    padding-top: 40px;
    height: auto;
  }
  #services {
    display: flex;
    align-items: center;
    svg {
      margin: 5px 0 0 5px;
    }
  }
  .phone {
    svg {
      margin-right: 7px;
    }
  }
  &.back_menu {
    background-color: white;
    height: 70px;
    /* box-shadow: 0px 0px 5px 0px #b1b1b1; */
    -webkit-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.23);
    -moz-box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.23);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.23);
    padding-top: 0;
    align-items: center;
    .logo {
      img {
        width: 120px;
      }
    }
    ul {
      .activeService {
        a {
          /* color:  #C0C0C0 !important; */
          color: black !important;
        }
      }
      a {
        color: #c0c0c0 !important;
        @media (max-width: 550px) {
          color: black !important;
        }
        &:hover {
          color: black !important;
        }
      }
      li {
        /* color: black !important; */
        color: #c0c0c0 !important;
        &:hover {
          /* color: #C0C0C0 !important; */
          color: black !important;
        }
        ul {
          background-color: white;
          a {
            color: black !important;
            &:hover {
              color: black !important;
            }
          }
        }
      }
      .phone {
        color: black !important;
        &:hover {
          color: #c0c0c0 !important;
        }
      }
    }
    .activeli {
      color: black !important;
    }
    .btn-toggle {
      span {
        background-color: black;
        &::before,
        &::after {
          background-color: black;
        }
      }
    }
  }
  .flecha_li {
    height: 15px;
    width: 15px;
    border: 1px solid white;
    border-width: 1.8px 1.8px 0 0;
    transform: rotate(135deg);
  }
  .logo {
    width: 30%;
    display: flex;
    align-items: center;
    padding-left: 75px;

    @media (max-width: 1024px) {
      padding-left: 35px;
    }
    img {
      width: 122px;
      transition: width 0.5s ease;
      @media (max-width: 550px) {
        width: 90px;
      }
    }
  }
  .menu {
    width: 70%;
    display: flex;
    justify-content: end;
    padding-right: 75px;
    gap: 20px;
    @media (max-width: 1024px) {
      flex-direction: column;
      background-color: #f1f0eb;

      position: absolute;
      top: 0;
      width: 100% !important;
      transform: translateX(1000px);
      transition: transform 0.5s ease;
      padding-right: 0;
      padding: 70px 0 20px 40px;
      height: 100vh;
    }
    @media (max-width: 550px) {
      transform: translateX(550px);
      background-color: #f1f0eb;
      position: fixed;
    }
    @media (max-width: 1024px) and (orientation: landscape) {
      transform: translateX(1000px);
    }
    &-scroll {
      flex-grow: 1;
      min-height: 180px;
      position: relative;
      .scroll-overlay {
        top: 0;
        left: 0;
        height: 100%;
        position: absolute;
        width: 100%;
        pointer-events: none;
        &::before,
        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          left: 0;
          height: 60px;
          z-index: 10;
        }
        &::before {
          top: 0;
          background: linear-gradient(to bottom, #f1f0eb, transparent);
        }
        &::after {
          bottom: 0;
          background: linear-gradient(to bottom, transparent, #f1f0eb);
        }
      }
    }
    &-footer {
      flex: none;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      gap: 20px;
      @media (max-width: 550px) {
        gap: 0;
        padding-bottom: 50px;
      }
    }
    /* @media (max-height: 667px) {
            overflow: scroll;
        } */
    ul {
      display: flex;
      align-items: center;
      max-width: 650px;
      a {
        color: white;
        text-decoration: none;
        border-bottom: 4px solid #ffff02;
        align-items: center;
        display: flex;
        font-family: "HelveticaNeue";
        font-size: 20px;
        margin-top: 6px;
        padding-bottom: 5px;
        &:hover {
          color: #c0c0c0;
        }
        img {
          width: 20px;
          margin-right: 10px;
        }
      }
      .activeService {
        a {
          color: white;
        }
      }
      li {
        font-family: "HelveticaNeue";
        font-weight: 400;
        list-style: none;
        color: #c0c0c0;
        font-size: 20px;
        position: relative;
        cursor: pointer;
        margin-right: 30px;
        img {
          padding: 0 5px;
        }
        a {
          border: none;
          color: #c0c0c0;
          &:hover {
            color: white;
          }
        }
        ul {
          position: absolute;
          height: 0;
          bottom: 0;
          overflow: hidden;
          left: -5px;
          width: 155px;
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          transition:
            height 0.8s ease,
            bottom 0.8s ease;
          li {
            padding: 5px 5px;
            display: flex;
            flex-direction: column;
            a {
              border: none;
              color: #c0c0c0;
              &:hover {
                color: white;
              }
            }
          }
        }
        &:hover {
          color: white;
          ul {
            height: 270px;
            bottom: -275px;
          }
        }
      }
      @media (max-width: 1200px) {
        padding-right: 15px;
      }
      @media (max-width: 1024px) {
        flex-direction: column;
        max-height: 100%;
        overflow-y: auto;
        padding: 30px 0;
        align-items: center;
        opacity: 0;
        transition: opacity 0.2s ease;
        align-items: flex-start;
        li {
          font-family: "NeueHaasDisplayMedium";
          font-size: 30px;
          color: black;
          padding: 0 0 9px;
          a {
            font-family: "NeueHaasDisplayMedium";
            letter-spacing: -0.03em;
            font-weight: 700;
            font-size: 30px;
            margin: 0;
            padding: 0;
            color: black;
            @media (max-width: 550px) {
              font-size: 32px;
            }
            @media (max-width: 390px) {
              font-size: 31px;
            }
          }
        }
      }
      @media (max-width: 550px) {
        height: auto;
      }
    }
    .activeli {
      color: white;
    }
    .bottom {
      width: 80%;
      display: flex;
      flex-direction: column;

      a {
        color: black;
        font-family: "NeueHaasDisplayMedium";
        font-size: 30px;
        text-decoration: none;
      }

      .phone_mobile {
        svg {
        }
        color: black;
        font-family: "HelveticaNeueRoman";
        font-weight: 400;
        margin-top: 13px;
        font-size: 20px;
        text-decoration: underline;
        text-decoration-color: #ffff02;
        text-underline-offset: 4px;
        text-decoration-thickness: 3px;
        @media (max-width: 550px) {
          margin-top: 10px;
        }
        @media (max-width: 390px) {
          margin-top: 5px;
        }
      }
      .social {
        @media (max-width: 1024px) {
          margin: 8px 0 0px;
          display: flex;
          img {
            width: 20px;
            margin-right: 20px;
          }
        }
      }
    }
    .city {
      display: flex;
      align-items: flex-end;
      /* width: 100%;
      height: 100px; */
      margin-top: 20px;
      font-size: 18px;
      width: 100%;
      font-family: "HelveticaNeueRoman";
      font-weight: 400;
      letter-spacing: -0.03em;
      @media (max-width: 390px) {
        margin-top: 15px;
      }
    }
  }
  .icon_menu {
    position: absolute;
    right: 50px;
    /* top: 10px; */
    display: none;
    @media (max-width: 1024px) {
      display: block;
    }
    @media (max-width: 550px) {
      right: 40px;
    }
  }
  .btn-toggle {
    width: 50px;
    height: 30px;
    margin-right: 0px !important;
    cursor: pointer;
    position: relative;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      height: 2.5px;
      width: 60%;
      background-color: white;
      transition: width 0.5s;
      &::before,
      &::after {
        content: "";
        width: 100%;
        height: 85%;
        background-color: white;
        position: absolute;
        left: 0;
        transition: width 0.5s;
      }

      &::before {
        top: -10px;
      }
      &::after {
        bottom: -10px;
      }
      &::before,
      &::after {
        transition: all 0.3s;
      }
    }
  }
`
const ContentPortada = styled.div`
  width: 100%;
  height: 92vh;
  min-height: 600px;
  display: flex;
  align-items: flex-end;
  position: relative;
  overflow: hidden;
  @media (max-width: 1620px) {
    max-height: 780px;
  }
  @media (max-width: 1435px) {
    max-height: 680px;
  }
  @media (max-width: 1024px) {
    max-height: 800px;
  }
  @media (max-width: 550px) {
    height: 100vh;
    max-height: fit-content;
  }
  @media (max-width: 380px) {
    min-height: 770px;
  }
  .background-black {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
  }
  .player-wrapper {
    justify-content: flex-end;
    @media (max-width: 550px) {
      justify-content: center;
      align-items: flex-end;
    }
  }
  video {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    @media (min-width: 1600px) {
      object-fit: none;
    }
    @media (max-width: 550px) {
      object-position: -800px;
    }
    @media (max-width: 380px) {
      object-position: -700px;
    }
  }
  .slogan {
    position: absolute;
    width: 667px;
    left: 100px;
    top: 52%;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 30px;
    @media (min-width: 1600px) {
      /* width: 45%; */
      top: 45%;
      width: 700px;
    }
    @media (max-width: 1024px) and (orientation: landscape) {
      top: 30%;
    }
    @media (max-width: 1024px) {
      left: 40px;
      width: 500px;
      top: 30%;
    }
    @media (max-width: 550px) {
      left: 40px;
      width: 65%;
      top: 30%;
      gap: 50px;
    }
    @media (max-width: 390px) {
      top: 25%;
      width: 60%;
      gap: 45px;
    }
    h2 {
      font-family: "HelveticaNeueBold";
      color: white;
      font-weight: 700;
      font-size: 57px;
      line-height: 62px;
      letter-spacing: -0.03em;
      padding: 0;
      @media (min-width: 1600px) {
        font-size: 60px;
      }
      @media (max-width: 1024px) {
        font-size: 50px;
        line-height: 55px;
      }
      @media (max-width: 550px) {
        font-size: 50px;
        line-height: 50px;
      }
      @media (max-width: 400px) {
        font-size: 45px;
        line-height: 45px;
      }
      @media (max-width: 360px) {
        font-size: 42px;
        line-height: 42px;
      }
    }
  }
`
const ContentConcepto = styled.div`
  height: 550px;
  margin-top: 1.75rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 0 100px;
  background-color: #f1f0eb;
  @media (max-width: 1350px) {
    padding: 0 50px;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 0 40px;
    margin-bottom: 1.75rem;
  }
  @media (max-width: 550px) {
    padding: 0 20px;
    flex-direction: column;
    margin: 14px auto 14px;
    max-width: calc(100% - 30px);
    padding-right: 20px;
    line-height: 42.73px;
  }
  @media (max-width: 450px) {
    padding-right: 30px;
  }
  @media (max-width: 390px) {
    flex-direction: column;
    margin: 15px auto;
    padding-right: 0px;
  }
  @media (max-width: 300px) {
    margin: 5px auto;
    padding: 15px;
  }
  .left {
    width: 50%;
    height: 100%;
    padding: 120px 0 120px 100px;
    @media (max-width: 1024px) {
      display: none;
    }
    position: relative;
    .swiper {
      height: 80%;
    }
    .swiper-slide {
      display: flex;
      align-items: center;
    }
    .referencia_concept {
      height: 100%;
      width: 97%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      @media (min-width: 1600px) {
        width: 93%;
      }
      p {
        color: #6c6c6c;
        position: relative;
        font-weight: normal;
        padding-bottom: 15px;
      }
      span {
        color: #6c6c6c;
        font-weight: 700;
      }
    }
  }
  .right {
    width: 50%;
    height: 100%;
    padding: 120px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    @media (max-width: 1024px) {
      width: 100%;
      height: 100%;
      padding-top: 50px;
      padding-bottom: 130px;
    }
    @media (max-width: 550px) {
      padding: 50px 0 85px 0;
    }
    .top {
      width: 89%;
      @media (min-width: 1600px) {
        width: 68%;
      }
      @media (max-width: 1024px) {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 20px;
      }
      @media (max-width: 550px) {
        margin-bottom: 0;
        padding-left: 0;
      }
    }
    .linea {
      width: 100px;
      height: 1px;
      background-color: black;
      margin-top: 30px;
      @media (max-width: 1024px) {
        display: none;
      }
      @media (max-width: 550px) {
        display: none;
      }
    }
    h1 {
      max-width: 700px;
      letter-spacing: -0.03em;
      b {
        display: block;
        color: black;
        padding: 0;
        font-family: "HelveticaNeueBold";
        font-weight: 700;
        letter-spacing: -0.03em;
        overflow-wrap: break-word;
        font-size: 38px;
        @media (max-width: 1024px) {
          font-size: 30px;
          display: inline;
        }
        @media (max-width: 550px) {
          font-size: 35px;
        }
      }
      span {
        color: black;
        font-family: "HelveticaNeueRoman";
        font-weight: normal;
        font-weight: 400;
        letter-spacing: -0.03em;
        overflow-wrap: break-word;
        font-size: 35px;
        @media (max-width: 1024px) {
          font-size: 30px;
        }
        @media (max-width: 550px) {
          font-size: 35px;
        }
      }
    }
    p {
      width: 85%;
      color: #6c6c6c;
      font-size: 23px;
      font-family: "HelveticaNeueRoman";
      font-weight: 400;
      letter-spacing: -0.03em;
      @media (min-width: 1600px) {
        width: 65%;
        font-size: 23px;
      }
      @media (max-width: 1024px) {
        padding-bottom: 20px;
        padding-top: 38px;
      }

      @media (max-width: 550px) {
        font-size: 19px;
        padding-bottom: 62px;
        padding-top: 38px;
      }
      @media (max-width: 390px) {
        width: 100%;
        font-size: 19px;
      }
    }
  }
`
const ContentServices = styled.div`
  width: 100%;
  height: 830px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: calc(56.25vw);
  background-color: #e6e6e6;
  overflow: hidden;
  .background-black {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
  }
  @media (max-width: 1024px) {
    height: 830px;
  }
  @media (max-width: 550px) {
    margin: 1.5rem auto 0;
    max-width: calc(100% - 30px);
    height: 730px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  h2,
  h3,
  p {
    color: white;
  }
  .texto {
    position: absolute;
    left: 100px;
    @media (max-width: 1350px) {
      left: 80px;
    }
    @media (max-width: 1024px) {
      left: 20px;
      top: 40px;
    }
    @media (max-width: 550px) {
      left: 20px;
    }
    h2 {
      font-size: 40px;
      font-family: "NeueHaasDisplayMedium";
      padding: 0;
      letter-spacing: normal;
      @media (max-width: 1024px) {
        font-size: 45px;
      }
      @media (max-width: 550px) {
        font-size: 35px;
      }
      @media (max-width: 390px) {
        font-size: 35px;
      }
    }
    p {
      font-size: 38px;
      line-height: 45px;
      margin-top: 12px;
      @media (max-width: 1024px) {
        font-size: 25px;
        line-height: 25px;
        margin-top: 0;
      }
      @media (max-width: 550px) {
        font-size: 20px;
        line-height: 25px;
      }
    }
  }
  .servicios {
    position: absolute;
    right: 100px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    @media (max-width: 1350px) {
      right: 80px;
    }
    @media (max-width: 1024px) {
      right: auto;
      left: 20px;
      top: 320px;
      align-items: flex-start;
    }
    h3 {
      font-size: 55px;
      line-height: 55px;
      cursor: pointer;
      border-bottom: 4px solid transparent;
      padding-left: 0;
      transition: padding-left 0.5s ease;
      font-family: "HelveticaNeue";
      padding-bottom: 7px;
      padding-top: 5px;
      @media (max-width: 1024px) {
        font-size: 45px;
        line-height: 45px;
      }
      @media (max-width: 550px) {
        font-size: 45px;
        line-height: 45px;
        letter-spacing: 1px;
      }
      @media (max-width: 390px) {
        font-size: 45px;
        line-height: 45px;
        letter-spacing: 1px;
      }
      &:hover {
        border-bottom: 4px solid #ffff02;
      }
    }
    p {
      margin-bottom: 30px;
      font-size: 30px;
      @media (max-width: 1024px) {
        font-size: 20px;
      }
    }

    .active {
      border-bottom: 4px solid #ffff02;
      padding-bottom: 7px;
    }
  }
`
const Video = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  background-color: #f1f0eb;
  cursor: pointer;
  @media (min-width: 1600px) {
    padding: 0 100px;
  }
  @media (max-width: 1024px) {
    padding: 0;
    height: auto;
    justify-content: space-evenly;
  }
  @media (max-width: 550px) {
    margin: 0 auto 55px;
    background-color: white;
  }
  h2 {
    font-size: 40px;
    padding: 30px 0;
    @media (max-width: 550px) {
      font-size: 24px;
      padding: 10px 0;
    }
  }
  .video {
    width: 100%;
    position: relative;
    @media (max-width: 1024px) {
      height: 75%;
      padding-left: 15px;
      padding-right: 15px;
    }
    @media (max-width: 550px) {
      height: 700px;
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      @media (max-width: 550px) {
        width: 100%;
        height: 700px;
        object-fit: cover;
      }
    }
    span {
      display: flex;
      align-items: center;

      h2 {
        font-family: "NeueHaasDisplayMedium";
        position: absolute;
        color: white;
        font-size: 50px;
        left: 100px;
        z-index: 1;
        @media (max-width: 1024px) {
          font-size: 45px;
          left: 20px;
        }
        @media (max-width: 550px) {
          font-size: 18px;
          left: 20px;
          display: none;
        }
      }
    }
    .show-enter-done {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
`
const ContentIndustries = styled.div`
  width: 100%;
  height: 150px;
  padding: 0 50px;
  background-color: black;
  @media (min-width: 1600px) {
    padding: 0 100px;
  }
  @media (max-width: 550px) {
    height: 100vh;
    padding: 0 10px;
  }
`
const ContentStudio = styled.div`
  width: 100%;
  padding: 120px 100px;
  background-color: #f1f0eb;
  @media (max-width: 1350px) {
    padding: 120px 50px;
  }
  @media (max-width: 1024px) {
    padding: 42px 20px 92px;
  }
  @media (max-width: 550px) {
    margin: 0 auto 0;
    padding: 42px 22px 92px;
    max-width: calc(100% - 30px);
  }
  @media (max-width: 390px) {
    padding: 42px 13px 92px;
  }
  h2 {
    padding: 0 0 25px 0;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    font-weight: 700;
    letter-spacing: -0.03em;
    display: flex;
    flex-direction: column;
    @media (max-width: 1024px) {
      font-size: 35px;
    }
    @media (max-width: 550px) {
      padding: 0 0 0 0;
    }
    @media (max-width: 390px) {
      font-size: 30px;
    }
    &::after {
      content: " ";
      margin-top: 40px;
      margin-bottom: 40px;
      width: 100px;
      height: 2px;
      background-color: black;
      @media (max-width: 550px) {
        margin-top: 40px;
        margin-bottom: 40px;
      }
    }
  }
  .studio {
    p {
      color: #6c6c6c;
      width: 915px;

      @media (max-width: 1024px) {
        width: 100%;
        font-size: 20px;
        padding-bottom: 30px;
      }
      @media (max-width: 550px) {
        font-size: 20px;
        padding-bottom: 0px;
        line-height: 22.47px;
      }
      @media (max-width: 390px) {
        font-size: 18px;
        line-height: 21.47px;
      }
    }
  }
`
const ContentProcess = styled.div`
  width: 100%;
  padding: 0 50px;
  background-color: #f1f0eb;
  display: flex;
  flex-direction: column;
  padding: 120px 0;
  @media (max-width: 1024px) {
    padding: 0;
  }
  @media (max-width: 550px) {
    margin: 0 auto 0;
    max-width: calc(100% - 30px);
  }
  h2 {
    padding: 0 0 25px 0;
    color: black;
    /* font-size: 40px; */
    font-family: "NeueHaasDisplayMedium";
    font-weight: 700;
    letter-spacing: -0.03em;
    display: flex;
    flex-direction: column;

    @media (max-width: 550px) {
      font-size: 35px;
      padding: 0 0 0 0;
    }
    &::after {
      content: " ";
      margin: 40px 0 20px 0;
      width: 100px;
      height: 2px;
      background-color: black;
      @media (max-width: 550px) {
        margin: 46px 0 40px 0;
      }
    }
  }
  .expertise-card {
    width: 50%;
    padding: 0 50px 0 100px;
    @media (max-width: 1350px) {
      padding: 0 50px 0 50px;
    }
    @media (max-width: 1024px) {
      width: 100%;
      padding: 51px 20px 69px;
    }
    @media (max-width: 360px) {
      padding: 51px 15px 69px;
    }
  }
  .process-card {
    width: 50%;
    padding: 0 100px 0 50px;
    @media (max-width: 1350px) {
      padding: 0 50px 0 50px;
    }
    @media (max-width: 1024px) {
      width: 100%;
      padding: 0 20px 84px;
    }
    @media (max-width: 390px) {
      padding: 0 28px 84px;
    }
    @media (max-width: 380px) {
      padding: 0 18px 84px;
    }
    @media (max-width: 360px) {
      padding: 0 13px 84px;
    }
  }
  .top {
    display: flex;
    padding-bottom: 120px;
    @media (max-width: 1024px) {
      flex-direction: column;
      padding-bottom: 40px;
    }
    @media (max-width: 550px) {
      flex-direction: column;
      padding-bottom: 40px;
    }
  }
  .process {
    width: 87%;
    @media (max-width: 1362px) {
      width: 100%;
    }
    @media (max-width: 1024px) {
      padding-bottom: 25px;
    }
    @media (max-width: 550px) {
      padding-bottom: 0;
    }
    p {
      color: #6c6c6c;
      font-weight: 400;
      letter-spacing: -0.03em;
      @media (max-width: 1362px) {
        font-size: 21px;
        line-height: 27px;
      }
      @media (max-width: 550px) {
        font-size: 20px;
        line-height: 21.47px;
      }
      @media (max-width: 390px) {
        font-size: 18px;
      }
    }
  }
  .slider {
    display: flex;
    justify-content: space-between;
    height: 70%;
    width: 100%;
    flex-wrap: wrap;
    padding: 0 100px;
    @media (min-width: 1600px) {
      height: 70%;
      width: 100%;
    }
    @media (max-width: 1350px) {
      padding: 0 50px;
    }
    @media (max-width: 1024px) {
      height: 80%;
      padding: 0;
    }
    @media (max-width: 550px) {
      display: none;
    }
  }
  .content-process {
    width: 32%;
    background-color: black;
    padding: 30px;
    position: relative;
    transition: background-color 0.5s ease;
    cursor: context-menu;
    @media (min-width: 1600px) {
      /* height: 500px;
            padding: 30px 50px; */
    }
    @media (max-width: 550px) {
      display: none;
    }
    @media (max-width: 1024px) {
      width: 100%;
      height: 90%;
      margin: 0 0 1.5rem;
      &:nth-child(3) {
        margin: 0;
      }
    }
    h3 {
      font-size: 30px;
      margin-bottom: 30px;
      font-family: "NeueHaasDisplayMedium";
    }
    h3,
    p {
      color: white;
    }
    p {
      margin-bottom: 20px;
      font-size: 18px;
      line-height: 21.47px;
      @media (min-width: 1600px) {
        font-size: 20px;
        line-height: 23.47px;
      }
      @media (max-width: 390px) {
        font-size: 17px;
        line-height: 20px;
      }
    }
  }
`
const ContentServDetail = styled.div`
  width: 100%;
  padding: 0 100px;
  background-color: #f1f0eb;
  @media (max-width: 1350px) {
    padding: 0 50px;
  }
  @media (max-width: 1024px) {
    padding: 40px 40px 0;
  }
  @media (max-width: 550px) {
    margin: 0 auto 0;
    max-width: calc(100% - 30px);
    padding: 84px 0 6px;
  }
  h2 {
    padding: 0 0 25px 0;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    letter-spacing: -0.03em;
    font-weight: 700;
    display: flex;
    flex-direction: column;
    &::after {
      content: " ";
      margin: 35px 0;
      width: 100px;
      height: 2px;
      background-color: black;
      @media (max-width: 550px) {
        margin: 46px 0px 40px;
      }
    }
    @media (max-width: 550px) {
      padding: 20px 0;
      font-size: 35px;
      padding: 0 19px;
    }
  }
  .content-services {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 120px;
    width: 872px;
    @media (min-width: 1600px) {
      width: 70%;
    }
    @media (max-width: 1024px) {
      width: 100%;
      padding-bottom: 60px;
    }
    @media (max-width: 550px) {
      width: 100%;
      padding-bottom: 86px;
    }
    p {
      padding-bottom: 5px;
      color: #6c6c6c;
      font-weight: 400;
      letter-spacing: -0.03em;
      @media (max-width: 550px) {
        font-size: 18px;
        padding: 0 35px;
      }
      @media (max-width: 360px) {
        padding: 0 11px;
      }
    }
  }
  .services {
    width: 100%;
    .card {
      width: 100%;
      padding: 0 0 120px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      overflow: hidden;
      @media (max-width: 1024px) {
        flex-direction: column;
        padding: 0 0 60px 0;
      }
      @media (max-width: 550px) {
        padding: 0;
      }
      .img,
      .text {
        width: 50%;
        height: 100%;
        @media (max-width: 1024px) {
          width: 100%;
        }
      }
      .img {
        height: 400px;
        position: relative;
        @media (max-width: 1024px) {
          height: 540px;
        }
        @media (max-width: 860px) {
          height: 440px;
        }
        a {
          position: absolute;
          display: block;
          width: 100%;
          height: 100%;
          z-index: 9;
          font-family: "HelveticaNeueBold";
          font-weight: 700;
          letter-spacing: -0.03em;
        }
        // .mobile {
        //   object-fit: cover;
        //   height: 100%;
        //   width: 100%;
        // }
        .vimeo {
          width: 100%;
          height: 100%;
          display: flex;
          iframe {
            position: absolute;
          }
        }
      }
      video {
        width: 100%;
        height: 100%;
      }
      &.reverse {
        flex-direction: row-reverse;
        @media (max-width: 1024px) {
          flex-direction: column;
        }
        .text {
          padding-left: 0;
          padding-right: 30px;
          @media (max-width: 1024px) {
            padding: 0;
          }
        }
        .img {
          padding-right: 0;
          padding-left: 30px;
          @media (max-width: 1024px) {
            padding: 0;
          }
        }
      }
      .text {
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: flex-start;
        padding-left: 30px;
        position: relative;
        @media (max-width: 1024px) {
          padding: 0;
        }
        h3 {
          font-family: "NeueHaasDisplayMedium";
          color: black;
          padding-bottom: 20px;
          @media (max-width: 1024px) {
            padding-bottom: 10px;
            padding-top: 10px;
          }
          @media (max-width: 550px) {
            color: white;
            position: absolute;
            top: -420px;
            padding-left: 20px;
            font-size: 35px;
          }
        }
        p {
          color: #6c6c6c;
          padding-bottom: 20px;
          @media (min-width: 1600px) {
            width: 700px;
          }
          @media (max-width: 550px) {
            display: none;
          }
        }
        button {
          @media (max-width: 1024px) {
            margin: 10px 0;
          }
          @media (max-width: 550px) {
            margin: 20px 19px 37px;
          }
        }
      }
    }
    .interactive-card {
      flex-direction: row-reverse;
      display: contents;
      width: 100%;
      @media (max-width: 1024px) {
        flex-direction: column;
      }
      .text {
        padding-left: 0;
        padding-right: 30px;
        @media (max-width: 1024px) {
          padding: 0;
        }
      }
      .img {
        padding-right: 0;
        padding-left: 30px;
        @media (max-width: 1024px) {
          padding: 0;
        }
        @media (max-width: 550px) {
          background-color: rgba(137, 137, 137, 1);
        }
      }
    }
  }
`
const ContentClientes = styled.div`
  width: 100%;
  height: 100%;
  padding: 120px 120px;
  background-color: ${(props) => (props.white ? "#F1F0EB" : "black")};
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1024px) {
    padding: 56px 20px;
    align-items: flex-start;
  }
  @media (max-width: 550px) {
    margin: 0 auto 55px;
    max-width: calc(100% - 30px);
    padding: 66px 0px 30px;
  }
  h2 {
    color: ${(props) => (props.white ? "black" : "white")};
    font-family: "NeueHaasDisplayMedium";
    font-weight: 700;
    letter-spacing: -0.03em;
    padding: 0;
    padding-bottom: ${(props) => (props.white ? 0 : "120px")};
    @media (max-width: 1024px) {
      width: 40%;
      padding-bottom: 30px;
    }
    @media (max-width: 550px) {
      padding-bottom: 30px;
      width: 80%;
      font-size: 35px;
      padding: 0px 30px 0px;
    }
  }
  img {
    width: 100%;
  }
`
const ContentClientsSay = styled.div`
  width: 100%;
  height: 594px;
  padding: 120px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1024px) {
    display: none;
  }
  @media (max-width: 550px) {
    display: block;
    padding: 0;
    height: 100%;
  }
  h2 {
    padding: 0;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    letter-spacing: -0.03em;
    font-weight: 700;
    @media (max-width: 550px) {
      font-size: 35px;
      text-align: center;
      font-weight: 700;
      padding: 0px 35px 60px;
    }
  }
  .swiper {
    width: 100%;
    height: 90%;
    @media (max-width: 550px) {
      height: 80%;
      margin-bottom: 70px;
    }
  }
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 0;
  }
  .swiper-pagination-bullet {
    background-color: #d9d9d9;
    width: var(
      --swiper-pagination-bullet-width,
      var(--swiper-pagination-bullet-size, 9px)
    );
    height: var(
      --swiper-pagination-bullet-height,
      var(--swiper-pagination-bullet-size, 9px)
    );
  }
  .swiper-pagination-bullet-active {
    background-color: black;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
  }
  .referencia {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    @media (max-width: 550px) {
    }
    p {
      color: #6c6c6c;
      text-align: center;
      letter-spacing: -0.03em;
      font-weight: 400;
      @media (max-width: 1362px) {
        font-size: 21px;
        line-height: 27px;
      }
      @media (max-width: 550px) {
        font-size: 17px;
        padding: 16px 8px 10px;
        line-height: 19.09px;
      }
      @media (max-width: 390px) {
        font-size: 16px;
        padding: 10px 0px;
      }
      &:nth-child(2) {
        font-family: "HelveticaNeuemedium";
      }
    }
  }
`
const ContentPhilosophy = styled.div`
  width: 100%;
  padding: 120px 100px;
  position: relative;
  background-color: #f1f0eb;
  display: flex;
  flex-direction: column;
  @media (max-width: 1350px) {
    padding: 120px 80px;
  }
  @media (max-width: 1024px) {
    padding: 40px;
  }
  @media (max-width: 550px) {
    display: none;
  }
  h2 {
    padding: 0 0 25px 0;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    display: flex;
    flex-direction: column;
    @media (max-width: 550px) {
      font-weight: 700;
    }
    &::after {
      content: " ";
      margin-top: 10px;
      width: 100px;
      height: 2px;
      background-color: black;
    }
  }
  .philosophy {
    width: 74%;
    padding-bottom: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media (max-width: 1024px) {
      height: 90%;
      width: 100%;
      padding-bottom: 0;
    }
    a {
      text-decoration: none;
      color: black;
    }
    p {
      color: #6c6c6c;
      padding-bottom: 35px;
      span {
        font-family: "NeueHaasDisplayMedium";
      }
    }
  }
  .boton_philosophy {
    @media (max-width: 1024px) {
      padding-bottom: 60px;
    }
  }
`
const ContentTeam = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1024px) {
    height: 500px;
  }
  @media (max-width: 550px) {
    display: block;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    @media (max-width: 1024px) {
      object-position: left;
    }
  }
`
const ContentQuestions = styled.div`
  width: 100%;
  height: auto;
  padding: 120px 100px;
  background-color: #f1f0eb;
  @media (max-width: 1350px) {
    padding: 120px 80px;
  }
  @media (max-width: 1024px) {
    padding: 40px;
  }
  @media (max-width: 550px) {
    margin: 0 auto;
    max-width: calc(100% - 30px);
    padding: 60px 30px 40px;
  }
  h2 {
    padding: 0 0 25px 0;
    color: black;
    font-family: "HelveticaNeueBold";
    display: flex;
    flex-direction: column;
    font-weight: 700;
    &::after {
      content: " ";
      margin: 40px 0;
      width: 100px;
      height: 2px;
      background-color: black;
      @media (max-width: 550px) {
        margin: 40px 0px 46px;
      }
    }
    @media (max-width: 550px) {
      font-size: 37px;
      padding: 0;
    }
    @media (max-width: 390px) {
      font-size: 30px;
    }
  }
  .questions {
    ul {
      width: 846px;
      @media (max-width: 1024px) {
        width: 100%;
        padding: 0;
      }

      li {
        list-style: none;
        font-size: 23px;
        font-weight: 600;
        font-family: "HelveticaNeue";
        cursor: pointer;
        padding: 10px 0;
        color: black;
        display: flex;
        flex-direction: column;
        &::after {
          content: " ";
          margin: 20px 0;
          width: 100%;
          height: 1px;
          background-color: black;
        }
        @media (max-width: 1024px) {
          font-size: 18px;
        }
        @media (max-width: 550px) {
          font-size: 18px;
          line-height: 20px;
          padding: 0;
        }
        div {
          height: auto;
          max-height: 0;
          overflow: hidden;
          transition: max-height 1s ease;
          p {
            color: #6c6c6c;
            padding: 10px 0 50px;
            @media (max-width: 550px) {
              padding: 10px 0 10px;
              font-size: 16px;
            }
          }
        }
        &:hover div {
          height: auto;
          max-height: 400px;
        }
        &:nth-child(2) {
          div {
            p {
              padding: 0;
              &:nth-child(1) {
                padding: 10px 0 0;
              }
              &:nth-child(8) {
                padding: 0 0 50px;
              }
            }
          }
          &:hover {
            div {
              max-height: 500px;
              @media (max-width: 550px) {
                max-height: 600px;
              }
            }
          }
        }
      }
    }
  }
`
const ContentFooter = styled.div`
  width: 100%;
  height: 646px;
  padding: 0 28px 28px;
  background-color: white;
  @media (max-width: 1024px) {
    padding: 0px;
    height: 640px;
    background-color: black;
  }
  @media (max-width: 550px) {
    height: auto;
    margin: 77px 15px 15px;
    width: 92%;
  }
  .top,
  .bottom {
    background-color: black;
    width: 100%;
    height: 50%;
    @media (max-width: 1024px) {
      height: 60%;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 120px 100px 0;
    @media (max-width: 1350px) {
      padding: 120px 80px 0;
    }
    @media (max-width: 1024px) {
      padding: 40px 40px 0;
      height: auto;
    }
    .left {
      display: flex;
      width: 100%;
      height: 100%;
      flex-direction: column;
      justify-content: flex-start;
      @media (max-width: 1024px) {
        align-items: flex-start;
      }
      h2 {
        padding: 0 0 20px 0;
        /* font-size: 40px; */
        @media (max-width: 550px) {
          padding: 0 0 25px 0;
        }
        font-family: "NeueHaasDisplayMedium";
        color: white;
        font-weight: 700;
      }
      p {
        color: white;
        font-family: "HelveticaNeue";
        font-size: 16px;
        font-weight: 400;
        letter-spacing: -0.03em;
        @media (max-width: 1024px) {
          width: 65%;
        }
        @media (max-width: 550px) {
          width: 100%;
        }
      }
      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media (max-width: 1024px) {
          width: 100%;
        }
        & > h2 {
          @media (max-width: 550px) {
            font-size: 38px;
          }
          @media (max-width: 390px) {
            font-size: 33px;
          }
        }
        a {
          padding: 20px;
          background-color: #ffff02;
          text-decoration: none;
          color: black;
          font-size: 20px;
          transition: background-color 0.2s ease;
          font-weight: 600;
          cursor: pointer;

          &:hover {
            background-color: #fbf970;
          }
        }
      }
      & > p {
        @media (max-width: 550px) {
          font-size: 16px;
        }
        @media (max-width: 390px) {
          font-size: 14px;
        }
      }
      .social {
        display: flex;
        width: 50px;
        padding: 20px 0;
        justify-content: space-between;
        @media (max-width: 550px) {
          padding: 35px 0;
          width: 70px;
        }
        img {
          width: 20px;
          @media (max-width: 550px) {
            width: 25px;
          }
        }
        a {
          color: white;
        }
      }
      .button_mobile {
        padding: 20px;
        background-color: #ffff02;
        text-decoration: none;
        color: black;
        font-size: 20px;
        transition: background-color 0.2s ease;
        font-weight: 400;
        letter-spacing: -0.03em;
        font-family: "HelveticaNeueRoman";
        cursor: pointer;
        margin-top: 20px;
        @media (max-width: 550px) {
          font-size: 20px;
          padding: 22px;
          margin-top: 10px;
          margin-bottom: 25px;
        }
        &:hover {
          background-color: #fbf970;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;
      @media (max-width: 550px) {
        width: 100%;
      }
      a {
        padding: 5px 15px;
        background-color: transparent;
        border-radius: 50px;
        border: 1px solid black;
        text-decoration: none;
        color: white;
        font-weight: bold;
        transition: background-color 0.2s ease;
        cursor: pointer;
        font-size: 30px;
        &:hover {
          transform: scale(1.02);
          box-shadow: 0 0 4px 7px rgb(254 238 19 / 15%);
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 100px 75px;
    @media (max-width: 1350px) {
      padding: 0 80px 120px;
    }
    @media (max-width: 1024px) {
      flex-direction: column;
      padding: 40px;
    }
    @media (max-width: 550px) {
      flex-direction: column;
      height: 65%;
      padding: 40px;
    }
    .address {
      display: flex;
      @media (max-width: 1024px) {
        width: 100%;
      }
      @media (max-width: 550px) {
        flex-direction: column;
      }
      .city {
        display: flex;
        justify-content: space-between;
        height: 106px;
        margin-right: 30px;
        gap: 30px;
        @media (max-width: 1420px) {
          margin-right: 5px;
        }
        @media (max-width: 550px) {
          justify-content: flex-start;
          margin-bottom: 40px;
          height: auto;
        }
        @media (max-width: 380px) {
          flex-wrap: wrap;
        }
        & > div {
          width: 158px;
          flex: none;
          * {
            display: block;
          }
        }
        p {
          font-size: 16px;
          font-weight: 700;
          letter-spacing: -0.03em;
          margin-bottom: 20px;
          color: white;
          @media (max-width: 550px) {
            margin-bottom: 20px;
            display: flex;
            margin-top: 5px;
          }
        }
        a {
          text-decoration: none;
          font-size: 16px;
          color: white;
          letter-spacing: -0.03em;
          cursor: pointer;
          @media (max-width: 550px) {
            display: flex;
          }
          &:nth-child(4) {
            text-decoration: underline;
            @media (max-width: 550px) {
              display: none;
            }
          }
        }
        &:nth-child(3) {
          margin-left: 40px;
          @media (max-width: 1420px) {
            margin-left: 20px;
          }
          @media (max-width: 550px) {
            margin-left: 0;
          }
        }
        img {
          width: 120px;
          height: 106px;
          object-fit: contain;
          @media (max-width: 550px) {
            display: flex;
          }
        }
      }
    }
    .datos {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      height: 112px;
      @media (max-width: 1024px) {
        align-items: flex-start;
        height: auto;
        width: 100%;
      }
      a {
        color: white;
        text-decoration: none;
        font-family: "NeueHaasDisplayLight";
        cursor: pointer;
      }
      p {
        color: white;
      }
      .icono-footer {
        height: 40px;
        @media (max-width: 550px) {
          height: auto;
          display: none;
        }
      }
      img {
        width: 100px;
        @media (min-width: 1600px) {
          width: 100px;
        }
        @media (max-width: 550px) {
          width: 102px;
          padding: 40px 0;
        }
      }
      .subscribe {
        font-size: 17px;
        font-weight: bold;
        font-family: "HelveticaNeueRoman";
        font-weight: 400;
        letter-spacing: -0.03em;
        padding-top: 5px;
        @media (max-width: 1362px) {
          font-size: 15px;
        }
        @media (max-width: 550px) {
          font-size: 15px;
          padding: 15px 0px 30px;
        }
        display: flex;
        flex-direction: column;
        &:hover {
          &::after {
            width: 75px;
          }
        }
      }
      div {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;
        @media (max-width: 1024px) {
          align-items: flex-start;
        }
        p {
          display: flex;
          font-size: 14px;
          text-align: end;
          line-height: normal !important;
          @media (max-width: 1362px) {
            text-align: start;
          }
          @media (max-width: 550px) {
            width: 100%;
            display: block;
            font-size: 13px;
          }
          @media (max-width: 390px) {
            font-size: 11px;
          }
          a {
            font-weight: normal;
            font-size: 14px;
            @media (max-width: 1362px) {
              font-size: 11px;
            }
            @media (max-width: 550px) {
              font-size: 13px;
            }
            @media (max-width: 390px) {
              font-size: 11.5px;
            }
          }
          span {
            margin: 0 5px;
          }
        }
        .subscribe {
          font-size: 17px;
          font-weight: bold;
          letter-spacing: -0.03em;
          padding-top: 5px;
          @media (max-width: 1362px) {
            font-size: 15px;
          }
          &:nth-child(2) {
            display: flex;
            flex-direction: column;
            @media (max-width: 1024px) {
              margin: 20px 0;
            }
            &::after {
              content: " ";
              width: 55px;
              height: 2px;
              background-color: #ffff02;
              transition: width 0.5s ease;
            }
            &:hover {
              &::after {
                width: 75px;
              }
            }
          }
        }
      }
    }
    .formulario {
      width: 415px;
      display: flex;
      flex-direction: row !important;
      justify-content: end;
      align-items: flex-end;
      padding: 15px 0px 15px;
      @media (max-width: 1024px) {
        width: 100%;
        justify-content: flex-start;
        padding: 40px 0px 40px;
      }
      @media (max-width: 550px) {
        width: 100%;
        flex-direction: column !important;
        align-items: flex-start;
      }
    }
  }
`
const Button = styled.a`
  text-decoration: none;
  font-family: ${(props) =>
    props.font ? "HelveticaNeue" : "HelveticaNeuemedium"};
  position: ${(props) => (props.absolute ? "absolute" : "relative")};
  padding: ${(props) => (props.padding ? "10px 0" : "17px")};
  background-color: ${(props) => (props.subrayado ? "transparent" : "#FFFF02")};
  color: ${(props) => (props.black ? "white" : "black")};
  cursor: pointer;
  transition: background-color 0.5s ease;
  display: flex;
  flex-direction: column;
  font-size: ${(props) => (props.size ? "20px" : "23px")};
  font-weight: ${(props) => (props.weight ? 400 : 700)};
  bottom: ${(props) =>
    props.portada
      ? 0
      : (props) =>
          props.servicios
            ? "-40px"
            : (props) =>
                props.mobile
                  ? "-10px"
                  : (props) =>
                      props.philosophy
                        ? "20px"
                        : (props) => (props.mobile2 ? "30px" : "110px")};
  z-index: 9;
  &:hover {
    background-color: ${(props) => (props.opacity ? "#FBF970" : "transparent")};
    ~ .subrayado {
      height: 20px;
    }
  }
  a {
    font-family: ${(props) =>
      props.font ? "HelveticaNeueRoman" : "HelveticaNeuemedium"};
    font-size: ${(props) => (props.size ? "18px" : "23px")};
    font-weight: ${(props) => (props.weight ? 400 : 700)};
    @media (max-width: 550px) {
      font-size: ${(props) => (props.size ? "18px" : "20px")};
      font-weight: 400;
    }
    @media (max-width: 390px) {
      font-size: ${(props) => (props.size ? "18px" : "19px")};
    }
    padding: 0 15px;
    &::after {
      content: " ";
      width: 100%;
      height: 15px;
      background-color: #ffff02;
      position: absolute;
      z-index: -1;
      bottom: 0;
      left: 0;
      transition: height 0.5s ease-in-out;
    }
    &:hover {
      &::after {
        height: 20px;
      }
    }
  }
  @media (max-width: 550px) {
    padding: ${(props) => (props.padding ? "10px 0" : "18px")};
  }
`
const Loading = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  &.hide {
    display: none;
  }
  img {
    width: 350px;
  }
  video {
    width: 180px;
    @media (max-width: 550px) {
      width: 150px;
    }
  }
`
const ModalVideo = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.882);
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    position: absolute;
    font-size: 30px;
    right: 100px;
    top: 30px;
    color: black;
    cursor: pointer;
  }
  iframe {
    width: 80%;
    height: 90%;
  }
`
const FormContact = styled.div`
  width: 100%;
  background-color: #f1f0eb;
  padding: 120px 100px;
  margin-top: 1.75rem;
  @media (max-width: 1024px) {
    padding: 40px;
  }
  .content-block {
    display: flex;
    flex-direction: column;
    .title {
      h2 {
        padding: 0 0 25px 0;
        color: black;
        font-family: "NeueHaasDisplayMedium";
        display: flex;
        flex-direction: column;
        &::after {
          content: " ";
          margin-top: 10px;
          width: 100px;
          height: 2px;
          background-color: black;
        }
      }
    }
    p {
      color: #6c6c6c;
      width: 55%;
      display: none;
    }
    @media (max-width: 1024px) {
      width: 55%;
      display: none;
    }
    @media (max-width: 550px) {
      width: 100%;
      margin-bottom: 10px;
      display: none;
      padding: 0 0 30px 0;
    }
  }
  .recaptcha {
    margin-top: 100px;
  }
  form {
    display: flex;
    flex-direction: column;
    width: 60%;
    align-items: flex-start;
    color: red;
    font-family: "HelveticaNeue";
    @media (max-width: 550px) {
      width: 100%;
    }

    input {
      font-family: "HelveticaNeueRoman";
      font-weight: 400;
      letter-spacing: -0.03em;
      width: 600px;
      height: 40px;
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #6c6c6c;
      font-size: 22px;
      outline: none;
      margin-top: 35px;
      &:-internal-autofill-selected,
      &:-webkit-autofill {
        background-color: #f1f0eb !important;
      }
      @media (max-width: 550px) {
        width: 100%;
        font-size: 18px;
      }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px #f1f0eb inset !important;
    }
    label {
      color: #6c6c6c;
      font-family: "HelveticaNeueRoman";
      font-weight: 400;
      letter-spacing: -0.03em;
      font-size: 22px;
      margin-top: 35px;
      @media (max-width: 550px) {
        width: 100%;
        font-size: 18px;
      }
    }
    select {
      width: 600px;
      font-family: "HelveticaNeueRoman";
      background-color: transparent;
      border: 1px solid #6c6c6c;
      color: #6c6c6c;
      outline: none;
      font-size: 18px;
      padding: 0 20px;
      height: 40px;
      margin-top: 10px;
      @media (max-width: 550px) {
        width: 100%;
      }
    }
    #my-radio-group,
    #checkbox-group {
      color: #6c6c6c;
      margin-top: 30px;
      font-family: "HelveticaNeueRoman";
      font-weight: 400;
      letter-spacing: -0.03em;
      font-size: 22px;
      @media (max-width: 550px) {
        font-size: 18px;
      }
    }
    button {
      background-color: #ffff02;
      padding: 20px;
      border: none;
      font-family: "HelveticaNeue";
      font-weight: 400;
      font-size: 22px;
      margin-top: 30px;
      @media (max-width: 550px) {
        font-size: 18px;
        font-weight: 700;
        color: black;
      }
    }
    input[type="text"],
    input[type="email"],
    input[type="number"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-radius: 0;
    }
    input[type="radio"],
    input[type="checkbox"] {
      width: 20px;
      margin-top: 0;
      border-radius: 5px;
      margin-right: 10px;
      background-color: #f1f0eb;
      accent-color: white;
      border: #6c6c6c 1px solid;
    }
    .row {
      width: 100%;
      display: flex;
      flex-direction: column;
      p {
        font-size: 18px;
        width: auto;
        padding-left: 20px;
      }
    }
    .files {
      width: 600px;
      background-color: transparent;
      border: 1px solid #6c6c6c;
      padding: 0 20px;
      margin: 30px 0 0;
      display: flex;
      height: 40px;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      @media (max-width: 550px) {
        width: 100%;
      }
      img {
        width: 20px;
      }
    }
    input[type="file"] {
      display: none;
    }
    textarea {
      font-family: "HelveticaNeue";
      margin-top: 20px;
      width: 600px;
      height: 100px;
      background-color: transparent;
      border: none;
      font-size: 22px;
      outline: none;
      border: 1px solid #6c6c6c;
      resize: none;
      padding: 10px;
      @media (max-width: 550px) {
        width: 100%;
        font-size: 18px;
      }
    }
    .radiom,
    .checkbox {
      width: 600px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @media (max-width: 550px) {
        width: 100%;
      }
      label {
        margin-top: 0;
        display: flex;
        align-items: center;
        font-size: 18px;
      }
    }
  }
`
const TermsPrivacyStyle = styled.div`
  width: 100%;
  /* position: fixed;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.815); */
  /* display: flex;
    justify-content: center; */
  div {
    padding: 120px 100px;
    background-color: #f1f0eb;
    /* background-color: white;
        margin-top: 60px;
        padding: 30px;
        width: 80%;
        height: 80%;
        overflow-y: scroll; */
    @media (max-width: 1024px) {
      padding: 120px 40px;
    }
    h2 {
      color: black;
      font-family: "NeueHaasDisplayMedium";
    }
    h4 {
      font-size: 23px;
      font-family: "NeueHaasDisplayMedium";
      margin-bottom: 10px;
    }
    a {
      color: #6c6c6c;
      font-size: 23px;
      @media (max-width: 550px) {
        font-size: 18px;
      }
    }
    p {
      margin-bottom: 30px;
      color: #6c6c6c;
    }
    ul {
      margin-left: 20px;
      li {
        font-size: 23px;
        font-family: "HelveticaNeue";
        color: #6c6c6c;
        @media (max-width: 550px) {
          font-size: 18px;
        }
      }
      margin-bottom: 30px;
    }
  }
`
const StikyTop = styled.div`
  cursor: pointer;
  width: 80px;
  z-index: 999;
  position: absolute;
  right: 20px;
  bottom: 60px;
  transition: transform 0.5s ease;
  @media (max-width: 550px) {
    bottom: 70px;
  }
  &:hover {
    transform: scale(1.15);
    -ms-transform: scale(1.15);
    -webkit-transform: scale(1.15);
  }
  img {
    width: 45px;
  }
  svg {
    fill: #fff !important;
  }
  .arrow {
    width: 30px;
    height: 30px;
    top: 50%;
    margin: -20px 0 0 -20px;
    -webkit-transform: rotate(45deg);
    border-right: none;
    border-bottom: none;
    border-left: 2px #fff solid;
    border-top: 2px #fff solid;
  }
`
const ThankYou = styled.div`
  width: 100%;
  height: 600px;
  background-color: #f1f0eb;
  display: flex;
  align-items: center;
  /* margin: 1.75rem; */
  padding: 100px;
  @media (max-width: 550px) {
    padding: 30px;
  }
  h2 {
    font-size: 50px;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    @media (max-width: 550px) {
      font-size: 30px;
    }
  }
  p {
    color: #6c6c6c;
    font-size: 28px;
    @media (max-width: 550px) {
      font-size: 20px;
      width: 100%;
    }
  }
`
const ThanksForSubscribing = styled.div`
  width: 100%;
  height: 600px;
  background-color: #f1f0eb;
  display: flex;
  align-items: center;
  /* margin: 1.75rem; */
  padding: 100px;
  @media (max-width: 550px) {
    padding: 30px;
  }
  h2 {
    font-size: 50px;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    @media (max-width: 550px) {
      font-size: 30px;
    }
  }
  p {
    color: #6c6c6c;
    font-size: 28px;
    @media (max-width: 550px) {
      font-size: 20px;
      width: 100%;
    }
  }
`
const ContentAssociated = styled.div`
  width: 100%;
  height: auto;
  padding: 100px 100px 50px;
  display: flex;
  column-gap: 20px;
  @media (max-width: 1024px) {
    padding: 50px 40px;
    flex-wrap: wrap;
    row-gap: 20px;
  }

  .card {
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media (max-width: 1024px) {
      width: 47%;
    }
    @media (max-width: 550px) {
      width: 100%;
    }
    img {
      width: 100%;
      height: 250px;
      object-fit: cover;
    }
    a {
      font-family: HelveticaNeuemedium;
      font-size: 16px;
      font-weight: 700;
      background-color: transparent;
      color: black;
      z-index: 1;
      width: fit-content;
      cursor: pointer;
      width: 100%;
      /* margin-top: 10px; */
      @media (max-width: 550px) {
        font-size: 18px;
      }
    }
    p {
      line-height: 20px;
    }
    .imagen_link {
      font-family: HelveticaNeuemedium;
      font-size: 16px;
      font-weight: 700;
      background-color: transparent;
      color: black;
      z-index: 1;
      width: fit-content;
      cursor: pointer;
      margin-top: 10px;
      vertical-align: top;
      background-image: linear-gradient(transparent 20%, var(--link-2) 10%);
      background-size: auto 175%;
      transition: background 0.8s ease-in-out;
      @media (max-width: 550px) {
        font-size: 18px;
      }

      &:hover {
        background-position-y: 100%;
      }
      &.moreTitle {
        &::after {
          height: 30px;
        }
        &:hover {
          &::after {
            height: 40px;
          }
        }
      }
    }
  }
`
const ContentPortafolio = styled.div`
  width: 100%;
  height: auto;
  padding: 1.75rem 1.75rem 0;
  @media (max-width: 550px) {
    padding: 15px 15px 0px;
  }
  @media (max-width: 430px) {
    padding: 0px 15px 15px;
  }
  img {
    width: 100%;
    margin-bottom: 30px;
    object-fit: cover;
    max-height: 1600px;
    @media (max-width: 550px) {
      height: 500px;
    }
  }
  h3 {
    color: #787878;
    font-family: "HelveticaNeue";
    font-weight: normal;
    font-size: 23px;
    @media (max-width: 550px) {
      font-size: 15px;
    }
  }
  div {
    padding: 0 0 30px;
    @media (max-width: 550px) {
      padding: 0 15px 30px;
    }
  }
`
const ContentBrandingDetail = styled.div`
  padding: 1.75rem 1.75rem;
  @media (max-width: 550px) {
    padding: 15px;
  }
  .hero-branding {
    width: 100%;
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    @media (max-width: 1024px) {
      height: 60vh;
    }
    @media (max-width: 550px) {
      height: 55vh;
    }
    .overlay-black {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.4);
    }
    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .paragraph {
    display: flex;
    justify-content: space-between;
    padding: 100px 0;
    @media (max-width: 1024px) {
      flex-direction: column;
      gap: 20px;
    }
    @media (max-width: 550px) {
      padding: 50px 0;
      flex-direction: column;
      gap: 20px;
    }
    &.gray {
      background-color: #f1f0eb;
    }
    &-pad {
      padding-left: 100px;
      @media (min-width: 1600px) {
        padding-left: 150px;
      }
      @media (max-width: 1024px) {
        padding-left: 80px;
      }
      @media (max-width: 550px) {
        padding-left: 10px;
      }
      &-mini {
        padding-left: 150px;
        @media (min-width: 1600px) {
          padding-left: 200px;
        }
        @media (max-width: 1024px) {
          padding-left: 80px;
        }
        @media (max-width: 550px) {
          padding-left: 10px;
        }
      }
    }
    .flex-end {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding-right: 50px;
      @media (min-width: 1600px) {
        padding-right: 225px;
      }
      @media (max-width: 1024px) {
        padding-left: 80px;
      }
      @media (max-width: 550px) {
        padding-left: 10px;
      }
    }
    .linea {
      width: 100px;
      height: 2px;
      background-color: black;
      margin: 20px 0 30px 0;
    }
  }
  .w35 {
    width: 35%;
    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 550px) {
      width: 90%;
    }
  }
  .w45 {
    width: 45%;
    @media (max-width: 1024px) {
      width: 85%;
    }
    @media (max-width: 550px) {
      width: 95%;
    }
  }
  .w50 {
    width: 50%;
    @media (max-width: 1024px) {
      width: 85%;
    }
    @media (max-width: 550px) {
      width: 100%;
    }
  }
  .w55 {
    width: 55%;
    @media (max-width: 1024px) {
      width: 95%;
    }
    @media (max-width: 550px) {
      width: 100%;
    }
  }
  .w60 {
    width: 60%;
    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 550px) {
      width: 90%;
    }
  }
  .w70 {
    width: 70%;
    @media (max-width: 550px) {
      width: 100%;
    }
  }
  .w80 {
    width: 80%;
    @media (max-width: 1024px) {
      width: 90%;
    }
    @media (max-width: 550px) {
      width: 95%;
    }
  }
  .w85 {
    width: 85%;
    @media (max-width: 550px) {
      width: 100%;
    }
  }
  .desk-w30 {
    @media (min-width: 1600px) {
      width: 30%;
    }
  }
  .desk-w39 {
    @media (min-width: 1600px) {
      width: 39%;
    }
  }
  .desk-w34 {
    @media (min-width: 1600px) {
      width: 34%;
    }
  }
  .desk-w45 {
    @media (min-width: 1600px) {
      width: 45%;
    }
  }
  .desk-w50 {
    @media (min-width: 1600px) {
      width: 50%;
    }
  }
  .txt-bold {
    font-family: "NeueHaasDisplayMedium";
    font-weight: bold;
    font-size: 38px;
    line-height: 40px;
    @media (min-width: 1600px) {
      font-size: 35px;
      line-height: 40px;
    }
    @media (max-width: 550px) {
      font-size: 35px;
      line-height: 35px;
    }
  }
  .txt-normal {
    font-size: 35px;
    line-height: 40px;
    @media (max-width: 1024px) {
      font-size: 32px;
      line-height: 35px;
    }
    @media (max-width: 550px) {
      font-size: 23px;
      line-height: 25px;
    }
  }
  .txt-mini {
    color: #6c6c6c;
    &-pad-top {
      padding-top: 20px;
      color: #6c6c6c;
    }
  }
  .txt-title {
    font-size: 38px;
    line-height: 40px;
    padding: 0 0 25px 0;
    color: black;
    font-family: "NeueHaasDisplayMedium";
    display: flex;
    flex-direction: column;
    @media (max-width: 550px) {
      padding: 0 0 30px 0;
      font-size: 35px;
      line-height: 30px;
    }
    &::after {
      content: " ";
      margin-top: 10px;
      width: 100px;
      height: 2px;
      background-color: black;
    }
  }
  .grid-gallery {
    display: grid;
    grid-template-columns: 1fr 0.5fr 0.5fr 1fr;
    grid-auto-rows: 600px;
    @media (min-width: 1600px) {
      grid-auto-rows: 750px;
      column-gap: 60px;
    }
    @media (max-width: 1599px) {
      grid-auto-rows: 800px;
      gap: 3rem;
    }
    @media (max-width: 1350px) {
      grid-auto-rows: 650px;
    }
    @media (max-width: 1024px) {
      grid-auto-rows: 400px;
    }
    @media (max-width: 550px) {
      grid-auto-rows: 180px;
      gap: 15px;
    }
    @media (max-width: 390px) {
      grid-auto-rows: 150px;
    }
    gap: 11rem;
    img,
    video,
    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding-bottom: 15px;
    }
    .black {
      background-color: black;
    }
    &.just-one {
      grid-auto-rows: 700px;
      @media (min-width: 1600px) {
        grid-auto-rows: 800px;
      }
      @media (max-width: 550px) {
        grid-auto-rows: 400px;
      }
    }
    .span-column-4 {
      grid-column: span 4;
    }
    .span-column-3 {
      grid-column: span 3;
    }
    .span-column-2 {
      grid-column: span 2;
    }
    .span-column-1 {
      grid-column: span 1;
    }
    .span-row-1 {
      grid-row: span 1;
      height: 900px;
      @media (max-width: 1599px) {
        padding-bottom: 110px;
      }
      @media (max-width: 1350px) {
        padding-bottom: 30px;
        height: 700px;
      }
      @media (max-width: 1024px) {
        height: 500px;
      }
      @media (max-width: 550px) {
        height: 100%;
      }
    }
    .span-row-2 {
      grid-row: span 2;
    }
  }
`
const FormNewsletter = styled.div`
  form {
    width: 100%;
    padding-left: 10px;
    @media (max-width: 1024px) {
      padding-left: 15px;
    }
    @media (max-width: 550px) {
      padding-left: 0;
      padding-top: 20px;
    }
    .inputForm {
      display: flex;
      flex-direction: row !important;
      input {
        border: none;
        border-bottom: 2px solid #ffff02;
        width: 200px;
        height: 20px;
        outline: none;
        background-color: black;
        color: white;
        font-size: 10px;
        @media (max-width: 550px) {
          width: 300px;
        }
        @media (max-width: 360px) {
          width: 200px;
        }
      }
      button {
        border: none;
        background-color: transparent;
        cursor: pointer;
        position: absolute;
        right: 0;
        .sending-text {
          color: white;
          font-size: 10px;
          bottom: 2px;
        }
        svg {
          color: white;
        }
      }
    }
  }
  p {
    width: 100%;
    padding-left: 10px;
    font-size: 12px !important;
    color: white;
    @media (max-width: 1024px) {
      padding-left: 15px;
      font-size: 10px !important;
    }
    @media (max-width: 550px) {
      padding-left: 0;
    }
  }
`
export {
  ContentHeader,
  ContentPortada,
  ContentConcepto,
  ContentServices,
  ContentStudio,
  ContentProcess,
  ContentIndustries,
  ContentServDetail,
  ContentClientes,
  ContentClientsSay,
  ContentPhilosophy,
  ContentTeam,
  ContentQuestions,
  ContentFooter,
  ContentAssociated,
  ModalVideo,
  Video,
  Button,
  Loading,
  FormContact,
  TermsPrivacyStyle,
  StikyTop,
  ThankYou,
  ThanksForSubscribing,
  ContentPortafolio,
  ContentBrandingDetail,
  FormNewsletter,
}
